import { z } from "zod";

export const ExpensePaymentMethodSchema = z.enum([
  "cash",
  "bank_transfer",
  "other",
]);

export const CreateExpenseRecordSchema = z.object({
  expenseDate: z.string().min(1),
  categoryId: z.string().min(1),
  payeeName: z.string().min(1),
  amount: z.coerce.number().int().positive(),
  description: z.string().optional(),
  performanceEventId: z.string().optional(),
  notes: z.string().optional(),
  submit: z.boolean().optional(),
});

export type CreateExpenseRecordDTO = z.infer<typeof CreateExpenseRecordSchema>;

export const UpdateExpenseRecordSchema = CreateExpenseRecordSchema.partial();

export type UpdateExpenseRecordDTO = z.infer<typeof UpdateExpenseRecordSchema>;

export const RejectExpenseSchema = z.object({
  rejectionReason: z.string().optional(),
});

export type RejectExpenseDTO = z.infer<typeof RejectExpenseSchema>;

export const MarkExpensePaidSchema = z.object({
  paymentMethod: ExpensePaymentMethodSchema,
  paidAt: z.string().optional(),
  notes: z.string().optional(),
});

export type MarkExpensePaidDTO = z.infer<typeof MarkExpensePaidSchema>;

export const VoidExpenseSchema = z.object({
  voidReason: z.string().min(1),
});

export type VoidExpenseDTO = z.infer<typeof VoidExpenseSchema>;

export const AddExpenseAttachmentSchema = z.object({
  storageKey: z.string().min(1),
  fileName: z.string().min(1),
  contentType: z.string().optional(),
});

export type AddExpenseAttachmentDTO = z.infer<
  typeof AddExpenseAttachmentSchema
>;
